import { render, staticRenderFns } from "./client-chart.vue?vue&type=template&id=4bdfdaf6"
import script from "./client-chart.vue?vue&type=script&lang=js"
export * from "./client-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports